import { useAppSelector } from '@/Module/Store/Hook';

export const useLoggedIn = () => useAppSelector(state => state.auth.isLoggedIn);
